"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataGridStyleName = exports.HorizontalLines = exports.VerticalLines = exports.FocusVisible = exports.DataGridLines = exports.DataGridColors = void 0;
var TypeStyle = require("typestyle");
exports.DataGridColors = {
    Selected: "var(--data-grid-selected-background-color, #CFE9FE)",
    AltRow: "var(--data-grid-row-banding-background-color, #F5F5F5)",
    HeaderBackground: "var(--data-grid-header-background-color, rgba(255, 255, 255, 0.9))",
    SelectedLine: "var(--data-grid-selected-line-color, #939393)", // --elevation-border-on-light-medium
};
exports.DataGridLines = {
    HeaderBorderWidth: "var(--data-grid-header-border-width, 1px)",
    HeaderBorderStyle: "var(--data-grid-header-border-style, solid)",
    HeaderBorderColor: "var(--data-grid-header-border-color, #939393)",
    // HeaderDividerWidth: `var(--data-grid-header-divider-width, 1px)`,
    // HeaderDividerStyle: `var(--data-grid-header-divider-style, solid)`,
    // HeaderDividerColor: `var(--data-grid-header-divider-color, var(--data-grid-vertical-line-color, #C9C9C9))`, // --elevation-border-on-light-default
    HeaderDividerWidth: "var(--data-grid-vertical-line-width, 1px)",
    HeaderDividerStyle: "var(--data-grid-vertical-line-style, solid)",
    HeaderDividerColor: "var(--data-grid-vertical-line-color, #C9C9C9)",
    HorizontalLineWidth: "var(--data-grid-horizontal-line-width, 1px)",
    HorizontalLineStyle: "var(--data-grid-horizontal-line-style, solid)",
    HorizontalLineColor: "var(--data-grid-horizontal-line-color, #C9C9C9)",
    VerticalLineWidth: "var(--data-grid-vertical-line-width, 1px)",
    VerticalLineStyle: "var(--data-grid-vertical-line-style, solid)",
    VerticalLineColor: "var(--data-grid-vertical-line-color, #C9C9C9)", // --elevation-border-on-light-default
};
exports.FocusVisible = 'focus-visible';
exports.VerticalLines = 'vertical-lines';
exports.HorizontalLines = 'horizontal-lines';
exports.DataGridStyleName = TypeStyle.style({
    // DefaultScrollComponent is absolutely positioned so the grid element needs to be the relative parent
    position: 'relative',
    overflow: 'hidden',
    height: '100%',
    isolation: 'isolate',
    userSelect: 'none',
    $nest: (_a = {
            '&:focus': {
                outline: 'none',
            },
            '& [role="gridcell"]:focus, & [role="columnheader"]:focus': {
                outline: 'none',
            }
        },
        _a["&." + exports.FocusVisible + " [role=\"gridcell\"]:focus, &." + exports.FocusVisible + " [role=\"columnheader\"]:focus"] = {
            outline: "2px solid #0B5CAB",
            outlineOffset: -2,
        },
        _a)
});
//# sourceMappingURL=DataGridColors.js.map